import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectSubtitlesLanguages } from '@/redux/selectors/constantsSelectors';
import SimpleLabelValue from '@/components/_common/SimpleLabelValue';
import SchemaFormatBox from '@/components/_common/SchemaForm/SchemaFormatBox';
import { ProfileChip } from '@/components/OrderPlacement/OPStep1OrderDetails/OPProfileDetailsOutput';

type SubtitleBoxProps = {
  value: string[];
};

const SubtitleBox = ({ value }: SubtitleBoxProps) => {
  const SubtitleLanguages = useAppSelector(selectSubtitlesLanguages);

  return (
    <SchemaFormatBox label="subtitle">
      <StyledDiv>
        {value?.map((track, i) => {
          const lang = SubtitleLanguages?.find((l) => l.code.replace('_', '-') === track);
          return (
            <ProfileChip
              isSchema
              key={track}
              color="default"
              label={`Track ${i + 1}`}
              value={SimpleLabelValue({ label: lang?.label, value: track, fallback: track })}
            />
          );
        })}
      </StyledDiv>
    </SchemaFormatBox>
  );
};

export default SubtitleBox;

const StyledDiv = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'flex-start'
}));
